import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { Helmet } from 'react-helmet-async';
import { User as UserIcon } from '@phosphor-icons/react/dist/ssr/User';

import type { Metadata } from '@/types/v2/metadata';
import { useUser } from '@/hooks/v2/use-user';

import { SideNav } from './side-nav';

interface LayoutProps {
  children: React.ReactNode;
  metadata: Metadata;
}

export function Layout({ children, metadata }: LayoutProps): React.JSX.Element {
  const { user } = useUser();

  return (
    <>
      <Helmet>
        <title>{metadata.title}</title>
      </Helmet>
      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.paper', minHeight: '100vh' }}>
        <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', px: { xs: 2, md: 4 }, py: 3 }}>
          <Container disableGutters maxWidth="xl">
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
              <Avatar
                variant="rounded"
                sx={{ width: 48, height: 48, bgcolor: 'primary.main', fontSize: '1rem', fontWeight: 700 }}
              >
                {user?.first_name && user?.last_name ? (
                  `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`
                ) : (
                  <UserIcon size={22} />
                )}
              </Avatar>
              <Box>
                <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
                  {user?.first_name} {user?.last_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Profile &amp; account settings
                </Typography>
              </Box>
            </Stack>
          </Container>
        </Box>

        <Container maxWidth="xl" sx={{ py: 4, px: { xs: 2, md: 4 } }}>
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} sx={{ position: 'relative' }}>
            <SideNav />
            <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{children}</Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
}
